import { useEffect, useState } from 'react';
import { Alert, Button, CircularProgress, Stack } from '@mui/material';
import { Link as RouterLink, useParams } from 'react-router-dom';
import type { Performer } from 'api-client';
import { usePerformersApi } from '@/context/AppContext';
import { PerformerProfile } from './PerformerProfile';

export function PerformerDetails() {
  const { id } = useParams<{ id: string }>();
  const api = usePerformersApi();
  const [performer, setPerformer] = useState<Performer | null>(null);
  const [error, setError] = useState(false);
  useEffect(() => {
    let cancelled = false;
    setPerformer(null);
    setError(false);
    if (!id) return;
    api
      .performersRetrieve({ id })
      .then((profile) => {
        if (!cancelled) setPerformer(profile);
      })
      .catch(() => {
        if (!cancelled) setError(true);
      });
    return () => {
      cancelled = true;
    };
  }, [api, id]);
  return (
    <Stack spacing={3}>
      <Stack direction="row" useFlexGap flexWrap="wrap" gap={1}>
        <Button component={RouterLink} to="/performers/">
          Back to performers
        </Button>
        {performer && (
          <Button
            variant="contained"
            component={RouterLink}
            to={`/performers/${performer.id}/edit`}
          >
            Edit shared profile
          </Button>
        )}
      </Stack>
      {error ? (
        <Alert severity="error">
          This performer could not be loaded. Return to the directory and try
          again.
        </Alert>
      ) : performer ? (
        <PerformerProfile performer={performer} />
      ) : (
        <CircularProgress aria-label="Loading performer" />
      )}
    </Stack>
  );
}
